import { collection, getDocs, query, where, orderBy, limit } from 'firebase/firestore';
import { db } from '../config/firebase';
import { Ride } from '../types';

export class RideService {
  // Tüm yolculukları getir
  static async getAllRides(): Promise<Ride[]> {
    try {
      console.log('🚗 Tüm yolculuklar getiriliyor...');
      
      const ridesQuery = query(
        collection(db, 'rides'),
        orderBy('createdAt', 'desc')
      );
      
      const ridesSnapshot = await getDocs(ridesQuery);
      const rides: Ride[] = [];
      
      ridesSnapshot.forEach((doc) => {
        rides.push({ id: doc.id, ...doc.data() } as Ride);
      });

      console.log('✅ Yolculuklar getirildi:', rides.length);
      return rides;
    } catch (error: any) {
      console.error('❌ Yolculukları getirme hatası:', error);
      return [];
    }
  }

  // Belirli bir yolcunun yolculuklarını getir
  static async getPassengerRides(passengerId: string): Promise<Ride[]> {
    try {
      console.log('🚶 Yolcu yolculukları getiriliyor:', passengerId);
      
      const ridesQuery = query(
        collection(db, 'rides'),
        where('passengerId', '==', passengerId),
        orderBy('createdAt', 'desc')
      );
      
      const ridesSnapshot = await getDocs(ridesQuery);
      const rides: Ride[] = [];
      
      ridesSnapshot.forEach((doc) => {
        rides.push({ id: doc.id, ...doc.data() } as Ride);
      });

      console.log('✅ Yolcu yolculukları getirildi:', rides.length);
      return rides;
    } catch (error: any) {
      console.error('❌ Yolcu yolculuklarını getirme hatası:', error);
      return [];
    }
  }

  // Belirli bir şoförün yolculuklarını getir
  static async getDriverRides(driverId: string): Promise<Ride[]> {
    try {
      console.log('🚗 Şoför yolculukları getiriliyor:', driverId);
      
      const ridesQuery = query(
        collection(db, 'rides'),
        where('driverId', '==', driverId),
        orderBy('createdAt', 'desc')
      );
      
      const ridesSnapshot = await getDocs(ridesQuery);
      const rides: Ride[] = [];
      
      ridesSnapshot.forEach((doc) => {
        rides.push({ id: doc.id, ...doc.data() } as Ride);
      });

      console.log('✅ Şoför yolculukları getirildi:', rides.length);
      return rides;
    } catch (error: any) {
      console.error('❌ Şoför yolculuklarını getirme hatası:', error);
      return [];
    }
  }

  // Son yolculukları getir
  static async getRecentRides(limitCount: number = 10): Promise<Ride[]> {
    try {
      console.log('🕒 Son yolculuklar getiriliyor...');
      
      const ridesQuery = query(
        collection(db, 'rides'),
        orderBy('createdAt', 'desc'),
        limit(limitCount)
      );
      
      const ridesSnapshot = await getDocs(ridesQuery);
      const rides: Ride[] = [];
      
      ridesSnapshot.forEach((doc) => {
        rides.push({ id: doc.id, ...doc.data() } as Ride);
      });

      console.log('✅ Son yolculuklar getirildi:', rides.length);
      return rides;
    } catch (error: any) {
      console.error('❌ Son yolculukları getirme hatası:', error);
      return [];
    }
  }

  // Durum bazında yolculukları getir
  static async getRidesByStatus(status: string): Promise<Ride[]> {
    try {
      console.log('📊 Durum bazında yolculuklar getiriliyor:', status);
      
      const ridesQuery = query(
        collection(db, 'rides'),
        where('status', '==', status),
        orderBy('createdAt', 'desc')
      );
      
      const ridesSnapshot = await getDocs(ridesQuery);
      const rides: Ride[] = [];
      
      ridesSnapshot.forEach((doc) => {
        rides.push({ id: doc.id, ...doc.data() } as Ride);
      });

      console.log('✅ Durum bazında yolculuklar getirildi:', rides.length);
      return rides;
    } catch (error: any) {
      console.error('❌ Durum bazında yolculukları getirme hatası:', error);
      return [];
    }
  }
} 